import { render } from "./InfoPanel.vue?vue&type=template&id=22ccc188&scoped=true&ts=true"
import script from "./InfoPanel.vue?vue&type=script&lang=ts"
export * from "./InfoPanel.vue?vue&type=script&lang=ts"

import "./InfoPanel.vue?vue&type=style&index=0&id=22ccc188&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ccc188"]])

export default __exports__